import api from './axios';
import { EventoCalendario, NotaRapida, CreateEventoDto, CreateNotaDto } from '../types/calendario';

export const calendarioApi = {
  getEventos: async (fechaInicio: string, fechaFin: string): Promise<EventoCalendario[]> => {
    const response = await api.get('/calendario/eventos', { params: { fechaInicio, fechaFin } });
    return response.data?.data || [];
  },

  crearEvento: async (data: CreateEventoDto): Promise<EventoCalendario> => {
    const response = await api.post('/calendario/eventos', data);
    return response.data?.data;
  },

  actualizarEvento: async (id: number, data: Partial<CreateEventoDto>): Promise<EventoCalendario> => {
    const response = await api.put(`/calendario/eventos/${id}`, data);
    return response.data?.data;
  },

  eliminarEvento: async (id: number): Promise<void> => {
    await api.delete(`/calendario/eventos/${id}`);
  },

  getNotas: async (): Promise<NotaRapida[]> => {
    const response = await api.get('/calendario/notas');
    return response.data?.data || [];
  },

  crearNota: async (data: CreateNotaDto): Promise<NotaRapida> => {
    const response = await api.post('/calendario/notas', data);
    return response.data?.data;
  },

  actualizarNota: async (id: number, data: Partial<CreateNotaDto & { completado?: boolean }>): Promise<NotaRapida> => {
    const response = await api.put(`/calendario/notas/${id}`, data);
    return response.data?.data;
  },

  eliminarNota: async (id: number): Promise<void> => {
    await api.delete(`/calendario/notas/${id}`);
  },

  completarNota: async (id: number, completado: boolean): Promise<NotaRapida> => {
    const response = await api.put(`/calendario/notas/${id}/completar`, { completado });
    return response.data?.data;
  },
};